<template>
  <div class="card shadow-lg card-hover-shadow card-bordered" style="border-width: 2px">
    <div class="card-body">
      <div cclass="bg-white p-4 border-primary shadow">
        <div class="row align-items-center" sstyle="border-bottom: solid #c0c0c0 2px">
          <div class="col font-size-2"><strong>At a glance...</strong></div>
          <div v-for="i in products.length" :key="i" class="col text-center">
            <img :src="products[i-1].lender.imageUrl" :title="products[i-1].lender.lenderName" :alt="products[i-1].lender.lenderName" style="max-width: 110px;"/>
          </div>
        </div>
  <!--      <div class="row">-->
  <!--        <div class="col mt-2"><strong>At A Glance</strong></div>-->
  <!--      </div>-->
        <div class="row mt-2">
          <div class="col" sstyle="margin-top: -20px"><strong>Product Summary</strong></div>
        </div>
        <div class="row align-items-center">
          <div class="col">Description</div>
          <div v-for="i in products.length" :key="i" class="col text-center">
            {{ products[i-1].description }}
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col">Product Type</div>
          <div v-for="i in products.length" :key="i" class="col text-center">
            {{ products[i-1].productType }}
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col">Fixed Period</div>
          <div v-for="i in products.length" :key="i" class="col text-center">
            {{ products[i-1].isFixedProduct ? products[i-1].initialPeriodDuration + " months" : "N/a" }}
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col">Maximum LTV</div>
          <div v-for="i in products.length" :key="i" class="col text-center">
            {{ (products[i-1].ltvMaxPercent/100) | prettyPercent }}
          </div>
        </div>
        <div class="row mt-2">
          <div class="col mt-2"><strong>Interest Rates</strong></div>
        </div>
        <div class="row align-items-center">
          <div class="col">Initial Rate</div>
          <div v-for="i in products.length" :key="i" class="col text-center">
            {{ products[i-1].initialInterestRate | prettyInterestRate }}
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col">Regular Rate</div>
          <div v-for="i in products.length" :key="i" class="col text-center">
            {{ products[i-1].interestRate | prettyInterestRate }}
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col">APRC</div>
          <div v-for="i in products.length" :key="i" class="col text-center">
            {{ products[i-1].calculations.aprc | prettyInterestRate }}
          </div>
        </div>
        <div class="row mt-2">
          <div class="col mt-2"><strong>Financials</strong></div>
        </div>
        <div class="row align-items-center">
          <div class="col">Initial Monthly Cost</div>
          <div v-for="i in products.length" :key="i" class="col text-center">
            {{ products[i-1].calculations.initialMonthlyCost | prettyMoney }}
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col">Regular Monthly Cost</div>
          <div v-for="i in products.length" :key="i" class="col text-center">
            {{ products[i-1].calculations.regularMonthlyCost | prettyMoney }}
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col">Full Term Cost</div>
          <div v-for="i in products.length" :key="i" class="col text-center">
            {{ products[i-1].calculations.fullTermCost | prettyMoney }}
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col">Monthly Saving</div>
          <div v-for="i in products.length" :key="i" class="col text-center">
            <MoneySaved :amount="products[i-1].calculations.monthlySaving"></MoneySaved>
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col">Annual Saving</div>
          <div v-for="i in products.length" :key="i" class="col text-center">
            <MoneySaved :amount="products[i-1].calculations.annualSaving"></MoneySaved>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col mt-2"><strong>Fees</strong></div>
        </div>
        <div class="row align-items-center">
          <div class="col">Arrangement</div>
          <div v-for="i in products.length" :key="i" class="col text-center">
            {{ products[i-1].fees.arrangementFee | prettyMoney }}
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col">Booking</div>
          <div v-for="i in products.length" :key="i" class="col text-center">
            {{ products[i-1].fees.bookingFee | prettyMoney }}
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col">Valuation</div>
          <div v-for="i in products.length" :key="i" class="col text-center">
            {{ products[i-1].fees.valuationFee | prettyMoney }}
          </div>
        </div>
        <div class="row mt-2">
          <div class="col mt-2"><strong>Overpayments</strong></div>
          <div v-for="i in products.length" :key="i" class="col text-center align-top">
            {{ products[i-1].isOverPaymentAllowed ? products[i-1].overpaymentNote : "Not permitted" }}
          </div>
        </div>
        <div class="row mt-2">
          <div class="col mt-2"><strong>Early Repayment Charges</strong></div>
          <div v-for="i in products.length" :key="i" class="col text-center align-top">
            {{ products[i-1].earlyRepaymentCharge ? products[i-1].earlyRepaymentChargeNote : "Not permitted" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MoneySaved from "@/components/products/MoneySaved";
export default {
  name: "CompareProducts",
  components: {MoneySaved},
  props: {
    products: {
      type: Array,
      default: null
    }
  }
}
</script>

<style scoped>

</style>